export default {
  methods: {
    getTranslations (key) {
      if (!this.$store.getters.translations) return null
      return this.$store.getters.translations[key] || null
    }
  }
}